import { useSelector } from 'react-redux';

export const useIsEditingDatabase = () => useSelector(({ utils: { isEditingDatabase } }) => isEditingDatabase);
